import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

const faqData = [
  {
    id: 1,
    question: "What services do you offer?",
    answer: "We provide Web Development, Mobile Apps, UI/UX Design, and AI Automation services tailored to your needs.",
  },
  {
    id: 2,
    question: "How does the hiring process work?",
    answer: "Our process is simple: We evaluate your requirements, match you with vetted developers, and get you started within 48 hours.",
  },
  {
    id: 3,
    question: "Do you provide ongoing support?",
    answer: "Yes, we offer flexible support and maintenance packages to ensure your software runs smoothly after deployment.",
  },
  {
    id: 4,
    question: "Can I hire developers on a monthly basis?",
    answer: "Absolutely. We offer flexible engagement models including monthly, hourly, and fixed-project based hiring.",
  },
];

const InfoGridSection = () => {
  const [activeId, setActiveId] = useState(1);

  return (
    <section className="relative w-full font-sans overflow-hidden bg-[#0E2A62]">

      <div className="absolute inset-0 z-0">
        <img
          src="/assets/hire-n/bg2.png"
          alt="Wave Background"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-[#01386A96] mix-blend-multiply"></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-[80px]">
        <div className="flex flex-col lg:flex-row">

          {/* --- LEFT SIDE: TITLE --- */}
          <div className="w-full lg:w-[35%] pt-[60px] pr-10 mb-12 lg:mb-0 flex items-start">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-white text-[20px] md:text-[30px] font-[600] leading-tight font-sora"
            >
              What Our Clients <br /> Are Saying
            </motion.h2>
          </div>

          {/* --- RIGHT SIDE: INTERACTIVE GRID --- */}
          <div className="w-full lg:w-[65%]">
            <div className="grid grid-cols-1 md:grid-cols-2">

              {faqData.map((item, index) => {
                const isActive = activeId === item.id;

                let borderClass = "border-[#FFFFFF66]";
                if (index === 0) borderClass = "md:border-r md:border-b border-b";
                if (index === 1) borderClass = "md:border-b border-b";
                if (index === 2) borderClass = "md:border-r border-b md:border-b-0";
                if (index === 3) borderClass = "";

                return (
                  <motion.div
                    key={item.id}
                    onMouseEnter={() => setActiveId(item.id)}
                    className={`relative p-8 md:p-[35px] min-h-[280px] flex flex-col justify-center transition-colors duration-500 cursor-pointer ${borderClass}
                      ${isActive ? "bg-[#F0F0F0]" : "bg-transparent"}
                    `}
                  >

                    <div className="relative z-10 h-full flex flex-col justify-between">
                      <h3 className={`text-[16px] md:text-[20px] font-[600] mb-4 font-sora transition-colors duration-300
                        ${isActive ? "text-[#0E2A62]" : "text-white"}
                      `}>
                        {item.question}
                      </h3>

                      {/* Answer / Read More Switch */}
                      <div className="mt-auto">
                        {isActive ? (
                          <motion.p
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="text-[#49577A] text-[14px] md:text-[16px] leading-relaxed font-graphik font-[500]"
                          >
                            {item.answer}
                          </motion.p>
                        ) : (
                          <div className="flex items-center gap-2 text-white font-medium text-sm group">
                            <span>Read More</span>
                            <ChevronRight size={16} className="text-[#F06115]" />
                          </div>
                        )}
                      </div>

                    </div>

                  </motion.div>
                );
              })}

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default InfoGridSection;